import React from 'react';
import PropTypes from 'prop-types';

export const FormSubheader = ({ children }) => {
  return <div className="swformsection__subheader">{children}</div>;
};

FormSubheader.propTypes = {
  children: PropTypes.any
};
